import React from "react";
import {
  Wrapper,
  Title,
  Subtitle,
  TextBlock,
  Time,
  IconLeft,
  IconRight,
  IconBottom
} from "./styled";
import Button from "../Button";

function Intro({ onNext }) {
  return (
    <Wrapper>
      <Title>Теперь пора проверить саму работу</Title>
      <Subtitle>
        Плагиатор позаимствовал текст чужой диссертации почти полностью, но
        отдельные слова заменил. Ваша задача как можно быстрее найти все замены
        и перейти к следующей странице
      </Subtitle>
      <TextBlock>
        <IconLeft />
        <IconRight />
        <IconBottom />
        Нужно кликнуть по любому не совпадающему слову в первом или втором
        фрагменте текста
      </TextBlock>
      <Time>У вас 2 минуты</Time>
      <Button onClick={() => onNext()}>Старт</Button>
    </Wrapper>
  );
}

export default Intro;
